<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="comboConfig.isOpen"
    id="add-sidebar"
  >
    <div class="flex items-center justify-between px-6 pb-2">
      <h4 class="font-bold text-2xl">Update Combo</h4>
      <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <div class="sidebar-content p-6 overflow-auto add-service-form">

        <h4 class="font-bold text-lg mb-3">Combo name</h4>
        <vs-input placeholder="Combo Name" v-validate="'required'" name="name" v-model="name" class="w-full" :danger="errors.has('name')"
              danger-text="The combo name field is required"/>

        <h4 class="font-bold text-lg mb-3 mt-4">Combo description</h4>
        <vs-textarea v-model="note" height="70"/>

        <h4 class="font-bold text-lg mb-4">Add item</h4>
        <vs-button style="min-width: 80px" class="mb-4" @click="addItem">+ Add item</vs-button>
        <div v-if="newList.length > 0">
          <div class="" v-for="(item , index) in newList" :key="index">
            <div class="flex">
              <div class="w-5/12 px-2">
                <p class="product-name font-medium truncate service-name" :style="`color: ${item.color_code}`">{{item.name}}</p>
              </div>
              <div class="w-1/6 px-2">
                <div v-if="item.price != null">
                  <p class="product-name font-medium truncate text-center">${{item.price}}</p>
                </div>
                <div v-else>
                  <p class="product-name font-medium truncate text-center">N/A</p>
                </div>
              </div>
              <div class="w-1/4 flex align-center">
                <span class="mt-2">$</span>
                <vs-input @input="changePrice($event,index)" class="w-1/2 mt-2 add-combo-price-item" v-model="item.price" :maxlength="5" v-if="item.price != null" v-on:keypress="isNumber($event)"></vs-input>
              </div>
              <div class="w-2/12 px-2">
                <img src="../../assets/images/trash-icon.png" class="mt-4 ml-4 trash-icon" @click.stop="removeItem(item)" />
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="w-5/12 px-2">
              <p class="product-name font-medium truncate service-name">Combo price</p>
            </div>
            <div class="w-1/6 px-2">
              <p class="product-name font-medium truncate text-center">${{combo_price}}</p>
            </div>
          </div>
        </div>

        <h4 class="font-bold text-lg mb-4">Category name</h4>
        <v-select @input="selectId($event)" label="name" :options="cateData" v-model="cateId" class="w-full" disabled :clearable="false" :searchable="false"></v-select>

        <h4 class="font-bold text-lg mb-6 mt-4">Online booking visibility</h4>
        <div class="flex align-center"><vs-checkbox class="m-0 mr-2" v-model="status">Service visible to client during online booking.</vs-checkbox></div>
        <p class="text-grey-custom" style="font-size: 12px">When enabled, this service will appear in your Booking Site and Embedded Widgets. This will not affect your ability to choose it when you create an appointment.</p>
        <p v-if="config.service_distinction">
        <vs-checkbox class="m-0 mr-2 mb-6" v-model="gocheckin_available">Service available on GoCheckin.</vs-checkbox>
        </p>
        <h4 class="text-lg font-bold mb-4">Status</h4>
        <ul class="switch-container">
          <li class="flex align-center">
            <vs-switch v-model="combo_is_active" @click.stop="switchActive"/>
            <p class="ml-3 p-0">
              <span class="text-primary" v-if="combo_is_active">Active</span>
              <span class="text-grey-custom" v-else>Inactive</span>
            </p>
          </li>
        </ul>
    </div>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <vs-button class="mr-6" style="min-width: 140px" @click="updateCombo">Submit</vs-button>
      <vs-button type="border" color="danger"  @click.stop="closeSidebar" style="min-width: 140px">Cancel</vs-button>
    </div>

    <popup-add-item :popupAddItem="popupAddItem" :listItemAdded="newList" @ConfirmList="confirmList" @ClosePopup="closePopup"></popup-add-item>
  </vs-sidebar>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: "vs-update-combo",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue"),
    'v-select': vSelect,
  },
  props: {
    comboConfig: {
      type: Object,
      required: true
    },
    serviceData: {
      type: Object,
      required: false
    },
    // activeServiceData: {
    //   type: Object,
    //   required: true
    // },
    activeStaffData: {
      type: Object,
      required: true,
    },
    cateData: {
      type: Array,
      required: true,
    },
  },
  data(){
    let listItemAdded = [];
    let newList = [];
    let temp = [];
    if(this.serviceData && this.serviceData.combo_item){
      temp = JSON.parse(JSON.stringify(this.serviceData.combo_item))
    }
    if(temp){
      for(let i = 0; i<temp.length; i++){
        if(temp[i].item_detail) {
          if(temp[i].item_id == temp[i].item_detail.id){
            temp[i].item_detail.price = temp[i].price;
          }
          listItemAdded.push(temp[i].item_detail);
        }
      }
    }
    this.$store.dispatch("staffList/GET_SERVICE_LIST", {page: 1, "per-page": 100}).then(() => {
      let serviceListWithSearch = [];
      serviceListWithSearch = this.$store.getters['staffList/serviceListWithSearch'](this.search);
       if(serviceListWithSearch){
        for(let j=0;j<serviceListWithSearch.length;j++){
          for(let k=0;k<listItemAdded.length;k++){
            if(serviceListWithSearch[j].id == listItemAdded[k].category_id){
              listItemAdded[k].color_code = serviceListWithSearch[j].color_detail.color_code;
            }
          }
        }
      }
      newList = [];
      for(let i = 0; i<listItemAdded.length; i++){
        let item = {};
        for (var key in listItemAdded[i]) {
          item[key] = listItemAdded[i][key];
        }
        newList.push(item)
      }
    });
    return {
      name : this.serviceData ? this.serviceData.name : "",
      note : this.serviceData ? this.serviceData.description : "",
      cateId: this.activeStaffData? this.activeStaffData.name : "",
      selectedId: this.activeStaffData ? this.activeStaffData.id : "",
      status: (this.serviceData.web_booking_visible == 0) ? false : true,
      distinctionValue: {name: "Show on GoCheckin & GoBooking", value: 0, },
      gocheckin_available: true,
      gobooking_available: true,
      popupAddItem: {
        isOpen: false
      },
      listItemAdded,
      combo_price: 0,
      total_duration: 0,
      newList,
      search: "",
      update_combo_key: 0,
      is_active: this.serviceData.status
    }
  },
  watch: {
    listItemAdded: {
      immediate: true,
      deep: true,
      handler() {
        if(this.serviceListWithSearch){
          for(let j=0;j<this.serviceListWithSearch.length;j++){
            for(let k=0;k<this.listItemAdded.length;k++){
              if(this.serviceListWithSearch[j].id == this.listItemAdded[k].category_id){
                this.listItemAdded[k].color_code = this.serviceListWithSearch[j].color_detail.color_code;
              }
            }
          }
        }
        if(this.listItemAdded) {
          this.newList = [];
          for(let i = 0; i<this.listItemAdded.length; i++){
            let item = {};
            for (var key in this.listItemAdded[i]) {
              item[key] = this.listItemAdded[i][key];
            }
            this.newList.push(item)
          }
        }
        this.getTotal();
      }
    },
  },
  methods: {
    switchActive(){
      this.is_active = this.is_active;
    },
    closeSidebar() {
      this.$emit("CloseSidebarCombo");
    },
    addItem(){
      this.popupAddItem.isOpen = true;
      this.update_combo_key++;
    },
    closeSidebarCombo(){
      this.$emit("CloseSidebarCombo")
    },
    confirmList(data){
      // this.listItemAdded = data;
      this.newList = data;
      this.popupAddItem.isOpen = false;
      this.getTotal()
    },
    getTotal(){
      let total = 0;
      let duration = 0;
      if(this.newList.length > 0){
        for(let i = 0; i<this.newList.length; i++){
          if(this.newList[i].price != null){
            total = parseFloat(total) + parseFloat(this.newList[i].price);
          }
          duration = duration + this.newList[i].duration
        }
      }
      this.combo_price = total;
      this.total_duration = duration;
    },
    closePopup(){
      this.popupAddItem.isOpen = false;
    },
    removeItem(item){
      if(this.newList.length > 0){
        for(let i = 0; i<this.newList.length; i++){
          if(this.newList[i].id == item.id){
            this.newList.splice(i, 1)
          }
        }
      }
      this.getTotal();
    },
    updateCombo(){
      if(this.name != ''){
        const obj = {
          id: this.serviceData.id,
          category_id: this.selectedId,
          name: this.name,
          description: this.note,
          price: this.combo_price,
          duration: this.total_duration,
          status: this.is_active ? 1 : 0,
          combo_items: []
        }
        for(let i = 0; i<this.newList.length; i++){
          const data = {
            item_price: parseFloat(this.newList[i].price),
            item_id: this.newList[i].id,
            item_type: "service",
            priority: this.newList[i].priority,
            item_data: [],
            status: this.newList[i].status
          }
          obj.combo_items.push(data)
        }
        if(this.newList.length == 0){
          this.$vs.notify({
            title:'Notification',
            text:'This combo must have at least one service!',
            color:'danger',
            position:'top-right'})
        }else{
          this.$emit("UpdateCombo", obj)
        }
      }
      this.$validator.validateAll();
    },
    changePrice(event, index){
      if (event != "") {
        this.newList[index].price = (event);
      } else {
        this.newList[index].price = 0;
      }
      // if(this.newList[index].price == 0 || this.newList[index].price == ''){
      //   this.newList[index].price = event
      // }
      this.getTotal();
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && this.input_price.indexOf(".") != -1)) {
          evt.preventDefault();
      } else {
          return true;
      }
    },
  },
  computed: {
    combo_is_active: {
      get() { return  this.is_active; },
        set(value) {
          this.is_active = value;
        }
    },
    config(){
      return this.$store.getters['auth/config'];
    },
    serviceListWithSearch() {
      return this.$store.getters['staffList/serviceListWithSearch'](this.search);
    },
  },
  // created() {
  //   this.$store.dispatch("staffList/GET_SERVICE_LIST", {page: 1, "per-page": 100})
  // }
}
</script>

<style scoped>
.trash-icon {
    width: 15px;
    height: 18.89px;
}
.add-combo-price-item input{
  padding: 0px;
  border-radius: 0px;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
</style>
